import {computed, onBeforeUnmount, onMounted, ref, watch} from 'vue'
import {jsonRpc} from '@communication'
import {useSessionStore} from '@/stores'

export type WaitingParty = 'client' | 'assistant' | null

const POLL_INTERVAL = 5000

export const useWaitingParty = () => {
  const session = useSessionStore() as any
  const waitingParty = ref<WaitingParty>(null)
  const isAssistant = computed<boolean>(() => session.info?.user?.party === 'assistant')
  const isClientWaiting = computed<boolean>(() => isAssistant.value && waitingParty.value === 'client')
  let timer: ReturnType<typeof setInterval> | undefined

  const refresh = async () => {
    const liteSessionId = session.conference
    if (!isAssistant.value || !liteSessionId) return
    try {
      const {party} = await jsonRpc.sendAndWait<{party: WaitingParty}>({
        method: 'con:waitingParty',
        params: {liteSessionId},
      })
      if (liteSessionId === session.conference) {
        waitingParty.value = party ?? null
      }
    } catch (error) {
      console.info('con:waitingParty failed', error)
    }
  }

  const stop = () => {
    clearInterval(timer)
    timer = undefined
  }

  const start = () => {
    stop()
    if (!isAssistant.value) return
    refresh()
    timer = setInterval(refresh, POLL_INTERVAL)
  }

  return {waitingParty, isClientWaiting, refresh, start, stop}
}
